import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/isAuthenticated";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Use our improved isAuthenticated function that checks token validity and refresh token
  const authenticated = isAuthenticated();

  console.log("PrivateRoute rendered, isAuthenticated:", authenticated);

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
